(function($) {

	'use strict';

	var init = function() {


		$(window).resize(function() {
            if($(window).width() > 992) {
                excerptToggle()
            } else {
                killExcerpt()
            }
        }).resize()

    };
    
    var excerptToggle = function() {

        var tile_item = $('.tiles__item')

        tile_item.each(function() {
            var height = $(this).find('.tiles__item__excerpt').outerHeight(true)
            
            $(this).find('.tiles__item__info').css('transform', 'translateY('+height+'px)')

            $(this).hover(function() {
                $(this).find('.tiles__item__info').addClass('transition')
                $(this).find('.tiles__item__info').css('transform', 'translateY(0)')
            }, function() {
                $(this).find('.tiles__item__info').css('transform', 'translateY('+height+'px)')
            })
            
        })
    }

    var killExcerpt = function() {

        var tile_item = $('.tiles__item')

        tile_item.each(function() {
            var height = '0'
            
            $(this).find('.tiles__item__info').css('transform', 'translateY('+height+'px)')
            
        })
    }

	$(document).ready(function() {
        init();
	});

})(jQuery);
